// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/user","layout":false,"id":"1"},"2":{"name":"login","path":"/user/login","parentId":"1","id":"2"},"3":{"path":"/withdrawal","name":"withdrawal","icon":"smile","parentId":"ant-design-pro-layout","id":"3"},"4":{"path":"/statistics","name":"statistics","icon":"barChart","parentId":"ant-design-pro-layout","id":"4"},"5":{"path":"/admin","name":"admin","icon":"crown","access":"canAdmin","parentId":"ant-design-pro-layout","id":"5"},"6":{"path":"/admin","redirect":"/admin/sub-page","parentId":"5","id":"6"},"7":{"path":"/admin/sub-page","name":"sub-page","parentId":"5","id":"7"},"8":{"path":"/","redirect":"/statistics","parentId":"ant-design-pro-layout","id":"8"},"9":{"path":"*","layout":false,"id":"9"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import('./EmptyRoute')),
'2': React.lazy(() => import(/* webpackChunkName: "p__User__Login__index" */'@/pages/User/Login/index.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__Withdrawal__index" */'@/pages/Withdrawal/index.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__Statistics__index" */'@/pages/Statistics/index.tsx')),
'5': React.lazy(() => import('./EmptyRoute')),
'6': React.lazy(() => import('./EmptyRoute')),
'7': React.lazy(() => import(/* webpackChunkName: "p__Admin" */'@/pages/Admin.tsx')),
'8': React.lazy(() => import('./EmptyRoute')),
'9': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'C:/Users/15103/Desktop/project/newmachine-admmin2/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
